import { useEffect, useState } from 'react';

import { Form, InputRadio } from '@/components';
import usePinsAccount from '@/hooks/usePinsAccount';
import { ResponseTarjetasTokenizadas } from '@/types/myAccount';
import { CardKey, CONF_TARJETAS, modernCapitalize } from '@/utils';

const initialState = {
  token: 'newCard',
};

export const TokenizedCards = ({ selectedCard }: { selectedCard: CardKey }) => {
  const nameCard = CONF_TARJETAS[selectedCard || 'CREDITO'].nombre;
  const { pinsData, updatePinsData } = usePinsAccount();

  const [cardsList, setCardsList] = useState<
    ResponseTarjetasTokenizadas | undefined
  >(undefined);
  const [cardSelected, setCardSelected] = useState(initialState);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    updatePinsData({ tokenizedCard: undefined });
    handleChangeSelected(initialState.token);
    setMounted(true);

    return () => {
      setCardsList(undefined);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      !pinsData.responseTokenizedCards?.warning &&
      pinsData.responseTokenizedCards?.tokenizadas
    ) {
      setMounted(true);
      setCardsList(pinsData.responseTokenizedCards);
    }
  }, [pinsData.responseTokenizedCards]);

  const handleChangeSelected = (token: string) => {
    setCardSelected({ token });
  };

  return (
    <div>
      {!mounted && 'Recuperando tarjetas guardadas...'}
      {cardsList &&
        cardsList.tokenizadas &&
        cardsList.tokenizadas?.length > 0 && (
          <Form.Form
            className="mb-4 mt-2"
            loading={!mounted}
            onSubmit={undefined}
          >
            <Form.Field className="space-y-3">
              <div className="flex flex-col max-h-[152px] overflow-auto style-scroll style-scroll--xs space-y-3">
                {cardsList &&
                  cardsList.tokenizadas &&
                  cardsList.tokenizadas.length > 0 &&
                  cardsList.tokenizadas.map((card) => {
                    return (
                      <div
                        key={card.token}
                        className="bg-white p-3 rounded-lg border "
                      >
                        <InputRadio.Wrapper>
                          <InputRadio.Input
                            className="w-full"
                            isChecked={cardSelected.token === card.token}
                            label={`${nameCard} ${modernCapitalize(
                              card.descripcionBin?.emisor || ''
                            )} **** **** **** ${card.lastFourDigits}`}
                            name="tokenCards"
                            value={String(card.codigoMedioPagoGdt)}
                            onChange={() => {
                              if (card?.token) {
                                handleChangeSelected(card?.token);
                                updatePinsData({ tokenizedCard: card });
                              }
                            }}
                          />
                        </InputRadio.Wrapper>
                      </div>
                    );
                  })}
              </div>
              <InputRadio.Wrapper
                className="bg-white p-3 rounded-lg border"
                // error={validateFieldError(touched.gender, errors.gender)}
                // label="tokenenized"
              >
                <InputRadio.Input
                  className="w-full"
                  isChecked={cardSelected.token === initialState.token}
                  label={`Nueva tarjeta`}
                  name="newCard"
                  value="newCard"
                  onChange={() => {
                    handleChangeSelected(initialState.token);
                    updatePinsData({ tokenizedCard: undefined });
                  }}
                />
              </InputRadio.Wrapper>
            </Form.Field>
          </Form.Form>
        )}
    </div>
  );
};
